import { Box } from "styled-system/jsx";
import { Spinner } from "@ttc3k/trekker";
import { css } from "styled-system/css";
import { lazy, Suspense } from "react";

const ApolloSandbox = lazy(() =>
  import("@apollo/sandbox/react").then(mod => ({
    default: mod.ApolloSandbox,
  })),
);

const sandboxWrapperClass = css({
  w: "full",
  h: "full",
  "& > div, & > div > iframe": {
    width: "100% !important",
    height: "100% !important",
  },
});

type DeveloperZoneSandboxProps = {
  endpoint: string;
  token: string;
  organizationId?: string;
  height?: string;
};

/**
 * Embeds the Apollo Sandbox iframe with the developer's bearer token and
 * org metadata pre-populated as shared headers. Lazy-loaded to keep the
 * sandbox bundle out of the main app chunk.
 */
export const DeveloperZoneSandbox = ({
  endpoint,
  token,
  organizationId,
  height = "600px",
}: DeveloperZoneSandboxProps) => {
  return (
    <Box w="full" h={height} borderRadius="100" overflow="hidden">
      <Suspense
        fallback={
          <Box
            w="full"
            h="full"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Spinner w="32px" h="32px" />
          </Box>
        }
      >
        <Box className={sandboxWrapperClass}>
          <ApolloSandbox
            initialEndpoint={endpoint}
            initialState={{
              sharedHeaders: {
                Authorization: `Bearer ${token}`,
                ...(organizationId
                  ? {
                      metadata: JSON.stringify({
                        entityId: organizationId,
                        type: "ORGANIZATION",
                      }),
                    }
                  : {}),
              },
              pollForSchemaUpdates: false,
            }}
          />
        </Box>
      </Suspense>
    </Box>
  );
};
